// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/bolt-slash.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'bolt-slash',
  version: 'outline',
  paths: [
    {
      d: 'M11.412 15.655 9.75 21.75l3.745-4.012M9.257 13.5H3.75l2.659-2.849m2.048-2.194L14.25 2.25 12 10.5h8.25l-4.707 5.043M8.457 8.457 3 3m5.457 5.457 7.086 7.086m0 0L21 21',
    },
  ],
}
